import React from 'react';
import PrivateRoute from '../../components/common/PrivateRoute';
import {Switch, Route} from 'react-router-dom';
import PageError from "../../components/layout/PageError";
import AccessControl from "../../pages/authorized/AccessControl";
import Membership from "../../pages/authorized/Membership/index";
import MembershipData from "../../pages/authorized/Membership/Data";
import Submission from "../../pages/authorized/Submission";
import Media from "../../pages/authorized/Media";
import Message from "../../pages/authorized/Message";
import Noticeboard from "../../pages/authorized/Noticeboard";
import Investment from "../../pages/authorized/fund/Investment";
import Fund from "../../pages/authorized/Fund";
import Monetize from "../../pages/authorized/Monetize";
import Transaction from "../../pages/authorized/Transaction";
import Company from "../../pages/authorized/Company";
import Job from "../../pages/authorized/Opportunity/Job";
import Other from "../../pages/authorized/Opportunity/Other";
import Application from "../../pages/authorized/Application";
import Payout from "../../pages/authorized/Payout";
import Survey from "../../pages/authorized/Survey";
import Loan from "../../pages/authorized/fund/Loan";
import Grant from "../../pages/authorized/fund/Grant";
import Applicant from "../../pages/authorized/Applicant";
import Employer from "../../pages/authorized/Employer";

const Private = () => {

        return (
            <Switch>
                    <PrivateRoute exact path="/membership" component={Membership} />
                    <PrivateRoute exact path="/membership/:id" component={MembershipData} />
                    <PrivateRoute exact path="/media" component={Media} />
                    <PrivateRoute exact path="/noticeboard" component={Noticeboard} />
                    <PrivateRoute exact path="/fund/loan" component={Loan} />
                    <PrivateRoute exact path="/fund/grant" component={Grant} />
                    <PrivateRoute exact path="/fund/investment" component={Investment} />
                    <PrivateRoute exact path="/application" component={Application} />
                    <PrivateRoute exact path="/applicant" component={Applicant} />
                    <PrivateRoute exact path="/monetize" component={Monetize} />
                    <PrivateRoute exact path="/message" component={Message} />
                    <PrivateRoute exact path="/survey" component={Survey} />
                    <PrivateRoute exact path="/payout" component={Payout} />
                    <PrivateRoute exact path="/transaction" component={Transaction} />
                    <PrivateRoute exact path="/transaction" component={Transaction} />
                    <PrivateRoute exact path="/access_control" component={AccessControl} />
                    <PrivateRoute exact path="/opportunity/job" component={Job} />
                    <PrivateRoute exact path="/opportunity/other" component={Other} />
                    <PrivateRoute exact path="/submission" component={Submission} />
                    <PrivateRoute exact path="/company" component={Company} />
                    <PrivateRoute exact path="/employer" component={Employer} />
                    <Route component={PageError} />
            </Switch>
        )
};

export default Private;
